import { render } from "./wfhAccomodation.vue?vue&type=template&id=d4891064"
import script from "./wfhAccomodation.vue?vue&type=script&lang=js"
export * from "./wfhAccomodation.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-deploy-to-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__